export default __webpack_public_path__ + "static/media/54.f14f4ac9.png";